import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import JobsTable from './jobs-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-awaiting-invoice')) {
  ReactDOM.render(<JobsTable
    url= "/api/v1/portal/jobs/awaiting-invoice"
    infiniteScroll={true}
    message_if_none = 'No jobs awaiting invoice.'
  />,
document.getElementById('react-component-g4-logistics-portal-awaiting-invoice'));
}
